import { useAppSelector } from 'hooks/hooks'
import { useCurrentCountry } from 'hooks/miscHooks'
import ReportExportButton from './common/ReportExportButton'
import ReportPageTemplate from './common/ReportPageTemplate'
import SubscriptionChurnReportFilter from './SubscriptionChurnReportFilter'
import SubscriptionChurnReportList from './SubscriptionChurnReportList'

const SubscriptionChurnReportPage = () => {
    const country = useCurrentCountry()
    const { filters } = useAppSelector((state) => state.subscriptionChurnReport)

    return (
        <ReportPageTemplate
            title="Presence Subscription Analysis"
            description="Analysis of providers who qualify for or have presence subscriptions"
            exportButton={
                <ReportExportButton
                    exportEndpoint="office/presence-subscription-churn-report/export"
                    filters={filters}
                    country={country}
                />
            }
            filterComponent={<SubscriptionChurnReportFilter />}
            listComponent={<SubscriptionChurnReportList />}
        />
    )
}

export default SubscriptionChurnReportPage
